import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { spacing64, spacing128, spacing16, breakWidth480 } from "@churchofjesuschrist/eden-style-constants";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Container = styled.div.withConfig({
  componentId: "sc-kq20a9-0"
})(["display:grid;overflow:auto;width:100%;height:100%;grid-template-areas:\"main main main main\" \". foot foot .\";grid-template-columns:", " 1fr 1fr ", ";grid-template-rows:min-content auto;@media (min-width:", "){grid-template-areas:\"previous main next\" \". foot .\";grid-template-columns:", " 1fr ", ";grid-template-rows:1fr ", ";}"], spacing16, spacing16, breakWidth480, spacing64, spacing64, spacing128);
const Previous = styled.div.withConfig({
  componentId: "sc-kq20a9-1"
})(["display:none;@media (min-width:", "){grid-area:previous;display:flex;align-items:center;justify-content:center;}"], breakWidth480);
const Main = styled.div.withConfig({
  componentId: "sc-kq20a9-2"
})(["grid-area:main;position:relative;"]);
const Next = styled.div.withConfig({
  componentId: "sc-kq20a9-3"
})(["display:none;@media (min-width:", "){grid-area:next;display:flex;justify-content:center;align-items:center;}"], breakWidth480);
const Foot = styled.div.withConfig({
  componentId: "sc-kq20a9-4"
})(["grid-area:foot;"]);
const ItemLayout = _ref => {
  let {
    main,
    previous,
    next,
    foot,
    className
  } = _ref;
  return /*#__PURE__*/_jsxs(Container, {
    className: className,
    children: [previous && /*#__PURE__*/_jsx(Previous, {
      children: previous
    }), /*#__PURE__*/_jsx(Main, {
      children: main
    }), next && /*#__PURE__*/_jsx(Next, {
      children: next
    }), /*#__PURE__*/_jsx(Foot, {
      children: foot
    })]
  });
};
ItemLayout.propTypes = {
  /** Media item to display */
  main: PropTypes.node,
  /** Previous Navigation */
  previous: PropTypes.node,
  /** Next Navigation */
  next: PropTypes.node,
  /** Footer, made of caption and attribution */
  foot: PropTypes.node,
  /** Class */
  className: PropTypes.string
};
export default ItemLayout;